<template lang="pug">
.avatar-container(
  :style="{ height: `${size}px`, 'min-height': `${size}px`, width: `${size}px`, 'min-width': `${size}px` }"
)
  .text-avatar.uppercase(
    :style="{ 'background-color': color, 'font-size': `${size * 0.47}px` }"
  ) {{ initials }}
</template>

<script setup lang="ts">
import { computed } from "vue";
import { type KeyCloakUser } from "../../services/userManagementKeyCloak";
const props = defineProps<{
  user?: KeyCloakUser;
  name?: {
    firstName: string;
    lastName: string;
  };
  size?: number | string | null;
}>();

const initials = computed(() => {
  const firstName = props.user?.firstName ?? props.name.firstName;
  const lastName = props.user?.lastName ?? props.name.lastName;
  if (firstName) {
    return `${firstName.charAt(0)}${lastName?.charAt(0) ?? ""}`;
  }
  return props.user?.email.charAt(0) ?? "";
});

const size = computed(() => (props.size ? props.size : 30));

const colors = [
  "#F44336",
  "#FF4081",
  "#9C27B0",
  "#673AB7",
  "#3F51B5",
  "#2196F3",
  "#03A9F4",
  "#00BCD4",
  "#009688",
  "#4CAF50",
  "#8BC34A",
  "#CDDC39",
  "#FFC107",
  "#FF9800",
  "#FF5722",
  "#795548",
  "#9E9E9E",
  "#607D8B",
];

const color = computed(() => {
  const id = props.user?.id ?? props.name.firstName + props.name.lastName;
  const seed = Math.abs(
    id.split("").reduce(function (a, b) {
      a = (a << 5) - a + b.charCodeAt(0);
      return a & a;
    }, 0),
  );
  return colors[seed % colors.length];
});
</script>

<style scoped>
.avatar-container {
  border-radius: 50%;
  overflow: hidden;
}

.text-avatar {
  height: 100%;
  width: 100%;
  font-size: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #eee;
  font-weight: 400;
}
</style>
